/**
 * Indicates the current view type which determines how the media will be presented.
 */
export enum ViewType {
  Unknown = 'unknown',
  Audio = 'audio',
  Video = 'video',
}
